import { render, staticRenderFns } from "./settingNewArea.vue?vue&type=template&id=51dc4646&scoped=true"
import script from "./settingNewArea.vue?vue&type=script&lang=js"
export * from "./settingNewArea.vue?vue&type=script&lang=js"
import style0 from "./settingNewArea.vue?vue&type=style&index=0&id=51dc4646&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dc4646",
  null
  
)

export default component.exports